import { Component, OnInit } from '@angular/core';
import { BrandDetailsGQL } from 'src/app/shared/graphql/brand-details.graphql';
import { environment } from 'src/environments/environment';
import { PropertyService } from './../shared/services/property.service';

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss']
})
export class HomeLayoutComponent implements OnInit {
  cookieBanner = true;

  constructor(private brandDetailsGQL: BrandDetailsGQL, private propertyService: PropertyService) { }

  ngOnInit(): void {
    if (document.cookie.split('; ').find(row => row.startsWith('cookieConsent=true'))) {
      this.cookieBanner = false;
    } else {
      this.cookieBanner = true;
    }
    this.getBrandDetails();
  }

  getBrandDetails(): void {
    this.brandDetailsGQL
    .watch({
      externalId: environment.brandExternalId,
    }).valueChanges.subscribe(({data}) => {
      this.propertyService.brandSubject.next(data.brandByExternalId);
    });
  }

  closeCookieBanner() {
    this.cookieBanner = false;
    document.cookie = "cookieConsent=true; path=/; max-age=" + 60*60*24*365; // 1 year
  }

}
